import { NotFound } from 'features/NotFound';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import OrderHistoryLayout from './OrderHistoryLayout';

const OrderHistory = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={path} component={OrderHistoryLayout} />
      <Route component={NotFound} />
    </Switch>
  );
};

export default OrderHistory;
